import {useAppDispatch, useAppSelector} from "../../../app/store";
import AdminLoader from "../AdminLoader";
import {Alert, Button, Col, Modal, Table} from "react-bootstrap";
import React, {useEffect} from "react";
import {ADMIN_LANG} from "../../../settings";
import {closeModal} from "../../../app/slices/modals/eventModal";
import {getEvent} from "../../../app/slices/modals/eventModal";
import {formatDate} from "../utils";


const EventModal = () => {
    const dispatch = useAppDispatch();
    const {isOpen, error, loading, event_id, message, date, changes} = useAppSelector((state) => state.eventModal);

    useEffect(() => {
        // NOTE: on React.StrictMode, this useEffect is called twice on dev mode
        if (event_id) {
            dispatch(getEvent(event_id));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [event_id]);

    const handleClose = () => {
        dispatch(closeModal())
    }

    const resultRows = changes.map((change) => {
        return (
            <tr key={change.key}>
                <td className='whitespace-no-wrap'>{change.field_name}</td>
                <td className='text-danger width-50' dangerouslySetInnerHTML={{__html: change.old_value}}></td>
                <td className='text-success width-50' dangerouslySetInnerHTML={{__html: change.new_value}}></td>
            </tr>
        )
    });

    return (
        <Modal size='xl' show={isOpen} onHide={handleClose} className='admin-modal'>
            {loading && <AdminLoader/>}
            <Modal.Header closeButton>
                <Modal.Title>{ADMIN_LANG.event_details}</Modal.Title>
            </Modal.Header>
            <Modal.Body className='row gy-3'>
                {error && (
                    <Alert variant='danger' dismissible>
                        <div dangerouslySetInnerHTML={{__html: error}}/>
                    </Alert>
                )}
                <Col xs={12} md={9} dangerouslySetInnerHTML={{__html: message}}>
                </Col>
                <Col xs={12} md={3}>
                    {date && <p>{formatDate(date)}</p>}
                </Col>
                <Col xs={12}>
                    <h3>{ADMIN_LANG.changes}</h3>
                    <div className='table-container'>
                        <Table responsive hover>
                            <thead>
                            <tr>
                                <th className='whitespace-no-wrap'>{ADMIN_LANG.field}</th>
                                <th>{ADMIN_LANG.old_value}</th>
                                <th>{ADMIN_LANG.new_value}</th>
                            </tr>
                            </thead>
                            <tbody>
                            {resultRows}
                            </tbody>
                        </Table>
                    </div>
                </Col>
            </Modal.Body>
            <Modal.Footer>
                <Button variant='outline-primary' onClick={handleClose}>
                    {ADMIN_LANG.close}
                </Button>
            </Modal.Footer>
        </Modal>

    )
}

export default EventModal;